import React from 'react'

export const DisplayValue = (value) => {
  return(
    <>
      {value ?? 'N/A'}
    </>
  )
}
